import type { Course } from "@models/ISchema";
import type { GroupVacancySource, InitialGroupValues, PopulationSubject } from "../../types";

const GROUP_VACANCIES_TAG = "ue.es/group_vacancies";

export const resolveGroupVacancySource = (tags: Course["tags"]): GroupVacancySource => {
  if (tags == null || !tags.trim()) return { kind: "manual" };

  let decoded: unknown;
  try {
    decoded = JSON.parse(tags);
  } catch {
    return { kind: "invalid" };
  }

  if (decoded === null || typeof decoded !== "object" || Array.isArray(decoded)) {
    return { kind: "invalid" };
  }

  if (!Object.prototype.hasOwnProperty.call(decoded, GROUP_VACANCIES_TAG)) {
    return { kind: "manual" };
  }

  const value = (decoded as Record<string, unknown>)[GROUP_VACANCIES_TAG];
  if (value === null || (typeof value === "string" && !value.trim())) {
    return { kind: "manual" };
  }
  if (typeof value === "number" && Number.isInteger(value) && value > 0) {
    return { kind: "catalog", capacity: value };
  }
  return { kind: "invalid" };
};

export const getLockedVacancies = (source: GroupVacancySource): string | null => {
  if (source.kind === "catalog") return String(source.capacity);
  if (source.kind === "invalid") return "";
  return null;
};

export const hasInvalidVacancySource = (
  subject: PopulationSubject,
  group: InitialGroupValues,
): boolean => {
  const lockedVacancies = getLockedVacancies(subject.vacancySource);
  return (
    lockedVacancies !== null &&
    (subject.vacancySource.kind === "invalid" || group.vacancies !== lockedVacancies)
  );
};
